import useAuth from 'hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { useUser } from 'controllers/contexts/user';
import { api } from 'controllers/network/apiClient';
import useHasPermission from 'hooks/useHasPermission';

export const OMNI_REPORTING_ACCESS = 'omniReportingAccess';

interface OmniReportingAccess {
  omniTrends: boolean;
}

export default function useOmniReportingAccess() {
  const { getShopId } = useAuth();
  const { user } = useUser();
  const shopId = getShopId();
  const canReadAnalytics = useHasPermission('analytics_read');
  const query = useQuery<OmniReportingAccess>({
    queryKey: [OMNI_REPORTING_ACCESS, shopId, user.guid, user.is_admin],
    queryFn: () => api.get('/v2/analytics/omni/reporting_access'),
    enabled: canReadAnalytics && !!shopId && !!user.guid,
    staleTime: 60_000,
    retry: 1,
  });

  return {
    ...query,
    hasOmniTrends:
      canReadAnalytics && !query.isError && query.data?.omniTrends === true,
  };
}
